import React from "react";
import ServiceTemplate from "./ServiceTemplate";
import { Cable } from "lucide-react";

const serviceData = {
  id: "fibre",
  title: "Fibre optique",
  description: "Installation et maintenance de réseaux fibre optique",
  icon: Cable,
  image: "/fibre.jpeg", // Updated path
  longDescription: [
    "Notre expertise en fibre optique vous garantit des connexions ultra-rapides et fiables pour votre infrastructure réseau. Nous assurons l'installation, la maintenance et l'optimisation de vos réseaux fibre optique.",
    "Nous utilisons les dernières technologies pour vous offrir les meilleures performances en termes de vitesse et de stabilité de connexion.",
  ],
  features: [
    "Installation de réseaux fibre optique",
    "Raccordement et soudure de fibres",
    "Tests et certification des liaisons",
    "Maintenance préventive et curative",
    "Optimisation des performances",
    "Documentation technique complète",
  ],
  benefits: [
    "Très haut débit garanti",
    "Fiabilité maximale des connexions",
    "Infrastructure évolutive",
    "Résistance aux perturbations électromagnétiques",
    "Support technique spécialisé",
  ],
};

const FibreOptique = () => {
  return <ServiceTemplate service={serviceData} />;
};

export default FibreOptique;
